/**
 * Action creator for loading a single patient by uuid.
 *
 * Returns a react-fetching-library request descriptor — pair with
 * `useQuery` or `usePatient` in the consuming feature. Pure function,
 * no store dependency.
 *
 * Endpoint: GET /accounts/:accountUuid/patients/:patientUuid
 */
const fetchPatientAction = ({ accountUuid, patientUuid }) => ({
  method: 'GET',
  endpoint: `/accounts/${accountUuid}/patients/${patientUuid}`,
});

export default fetchPatientAction;
